import BaseModelAPI from '../BaseModelAPI';

export default class OutgoingCheckStatus extends BaseModelAPI {
	static entity = 'outgoingcheckstatus';
	static entityName = 'outgoingcheckstatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.sequence = 0;
			this.remarks = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}